import { ApolloClient, OperationVariables } from "@apollo/client";
import { MutationResponseWithId, SimpleMutationResponse } from "./sharedTypes";

export type BacthedMutationOptions<TResponse, TVariables extends OperationVariables> = {
  mutation: any;
  variables: TVariables;
  responsePath: (data: TResponse) => MutationResponseWithId[] | undefined;
  ids: number[];
};

export async function batchedMutation<TResponse, TVariables extends OperationVariables>(
  client: ApolloClient<object>,
  options: BacthedMutationOptions<TResponse, TVariables>,
  abortSignal?: AbortSignal
): Promise<SimpleMutationResponse[]> {
  const { mutation, variables, responsePath, ids } = options;

  const results: SimpleMutationResponse[] = ids.map((id) => ({ id, success: false }));
  try {
    const responseFetch = await client.mutate<TResponse, TVariables>({
      mutation,
      variables,
      context: { fetchOptions: { signal: abortSignal } },
    });

    const responses = responsePath(responseFetch.data as TResponse);
    if (!responses) return results;

    for (const response of responses) {
      const result = results.find((e) => e.id === response.id);
      if (result) {
        result.success = response.success;
      }
    }
  } catch (error) {
    console.error(error);
  }

  return results;
}